import api from './api';

export const wfhService = {
  // Employee functions - Apply for WFH and manage own applications
  applyForWFH: async (wfhData) => {
    const response = await api.post('/wfh/apply', wfhData);
    return response.data;
  },

  // Several dates in one request: { dates, reason, reasons?: { date: reason }, skip_conflicts? }
  applyForWFHBulk: async (payload) => {
    const response = await api.post('/wfh/apply-bulk', payload);
    return response.data;
  },

  // Server-side conflict check before submitting
  checkWFHDates: async (dates) => {
    const response = await api.post('/wfh/check-dates', { dates });
    return response.data;
  },

  getMyWFHApplications: async (employeeId, params = {}) => {
    const response = await api.get(`/wfh/my-applications/${employeeId}`, { params });
    return response.data;
  },

  cancelWFHApplication: async (applicationId, employeeId) => {
    const response = await api.delete(`/wfh/cancel/${applicationId}`, {
      data: { employee_id: employeeId }
    });
    return response.data;
  },

  // Admin/HR functions - Manage all WFH applications
  getAllWFHApplications: async (params = {}) => {
    const response = await api.get('/wfh/all', { params });
    return response.data;
  },

  getTeamWFHRequests: async (params = {}) => {
    const response = await api.get('/wfh/team-requests', { params });
    return response.data;
  },

  updateWFHStatus: async (applicationId, statusData) => {
    const response = await api.put(`/wfh/update-status/${applicationId}`, statusData);
    return response.data;
  },

  updateWFHStatusBulk: async (payload) => {
    const response = await api.put('/wfh/update-status-bulk', payload);
    return response.data;
  },

  approveWFHApplication: async (applicationId, approvedBy) => {
    const response = await api.put(`/wfh/update-status/${applicationId}`, {
      status: 'APPROVED',
      approved_by: approvedBy
    });
    return response.data;
  },

  rejectWFHApplication: async (applicationId, approvedBy, rejectionReason) => {
    const response = await api.put(`/wfh/update-status/${applicationId}`, {
      status: 'REJECTED',
      approved_by: approvedBy,
      rejection_reason: rejectionReason
    });
    return response.data;
  },

  getWFHStatistics: async (params = {}) => {
    const response = await api.get('/wfh/statistics', { params });
    return response.data;
  }
};

export default wfhService;